import { AxiosResponse } from 'axios'
import { API } from '../config'
import { CreateSaleDTO, SaleDTO, UpdateSaleDTO } from 'src/dto/sale'

const BASE_URL = '/entity/VendaAnimal'

export class SaleService {
  public async getSaleList(farmId: string): Promise<AxiosResponse<SaleDTO[]>> {
    return await API.get(`${BASE_URL}/${farmId}`)
  }

  public async createSale(farmId: string, createNewSaleDto: CreateSaleDTO): Promise<AxiosResponse<SaleDTO>> {
    return await API.put(`${BASE_URL}/${farmId}`, createNewSaleDto)
  }

  public async updateSale(farmId: string, updateNewSaleDto: UpdateSaleDTO): Promise<AxiosResponse<SaleDTO>> {
    return await API.put(`${BASE_URL}/${farmId}`, updateNewSaleDto)
  }
}
